export const ADMIN_SCHOOL_CARD_OPTION = {
  USERS: 'users',
  PRODUCTS: 'products',
  CLASSES: 'classes',
  REPORTS: 'reports'
};
